<script setup lang="ts">
import SelectButton from 'primevue/selectbutton';
import { computed } from 'vue';
import { useColorScheme } from '@precon-tools-suite-by-shared/vue-color-schemes';
import { useI18n } from 'vue-i18n';

export interface Labels {
    dark: string;
    light: string;
}

export interface Icons {
    dark: string;
    light: string;
}

const { t } = useI18n();

const { modelValue, loading } = useColorScheme();

const options = computed(() => [
    {
        value: 'light',
        label: t('light'),
        icon: 'pi pi-sun',
    },
    {
        value: 'dark',
        label: t('dark'),
        icon: 'pi pi-moon',
    },
]);
</script>

<template>
    <SelectButton
        v-model="modelValue"
        :options="options"
        option-label="label"
        option-value="value"
        data-key="value"
        :disabled="loading"
    >
        <template #option="{ option }">
            <i
                :class="
                    loading && option.value === modelValue
                        ? 'pi pi-spinner pi-spin'
                        : option.icon
                "
                class="p-button-icon p-button-icon-left"
            />
            <span class="p-button-label">{{ option.label }}</span>
        </template>
    </SelectButton>
</template>

<i18n>
    {
        "en": {
            "light": "Light",
            "dark": "Dark"
        },
        "nl": {
            "light": "Licht",
            "dark": "Donker"
        },
        "fr": {
            "light": "Claire",
            "dark": "Sombre"
        }
    }
</i18n>
